import MusselGrowerSeedModal from './MusselGrowerSeedModal';
import OysterGrowerSeedModal from './OysterGrowerSeedModal';
import {
  IMusselSeeding,
  IOysterSeeding,
  ISeedingResource,
} from '../../../entities/growing.entities';
import {
  ILineResource,
  IMusselLineResource,
  IOysterLineResource,
} from '../../../entities/farms.entities';

interface Props {
  visible: boolean;
  lineData?: ILineResource;
  seedData?: ISeedingResource;
  onClose: (d: any) => void;
  onConfirm: (d: any) => void;
  overConfirm?: (d: any) => Promise<any>;
  confirmID?: number;
  className?: string;
  onlyView?: boolean;
  data?: any;
  warningMessage?: string;
}

const GrowerSeedModal = ({
  visible,
  lineData,
  seedData,
  onClose,
  onConfirm,
  className,
  onlyView,
  overConfirm,
  data,
  warningMessage,
}: Props) => (
  <>
    {lineData?.crop_type === 'MUSSEL' ? (
      <MusselGrowerSeedModal
        visible={visible}
        lineData={lineData as IMusselLineResource}
        seedData={seedData as IMusselSeeding}
        onClose={onClose}
        onConfirm={onConfirm}
        className={className}
        onlyView={onlyView}
        overConfirm={overConfirm}
        data={data}
        warningMessage={warningMessage}
      />
    ) : lineData?.crop_type === 'OYSTER' ? (
      <OysterGrowerSeedModal
        visible={visible}
        lineData={lineData as IOysterLineResource}
        seedData={seedData as IOysterSeeding}
        onClose={onClose}
        onConfirm={onConfirm}
        className={className}
        onlyView={onlyView}
      />
    ) : (
      <></>
    )}
  </>
);

export default GrowerSeedModal;
